module.exports = __webpack_public_path__ + "img/Online wishes list-pana.60ad79e0.svg";